import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const counter = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  inline-size: ${spacing(15.75)}; //126px
  border-radius: ${spacing(1.25)};
  background-color: ${cssTheme.default.day.controlMinor};

  & > * {
    white-space: nowrap;
  }
`
export const button = css`
  block-size: ${spacing(2.5)};
`
